import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SignaturePasswordAuthComponent } from './components/signature-password.component';
import { SignaturePinComponent } from './components/pin.component';
import { CertificateSelection } from './components/certificate-selection.component';
import { DialogModule } from 'primeng-lts/dialog';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { TableModule } from 'primeng-lts/table';
import { DirectivesModule } from '../../app/directives/directives.module';
import { DialogService } from 'primeng-lts/dynamicdialog';
import { FormPlycaModule } from '../../app/components/forms/formPlyca.module';

@NgModule({
  declarations: [SignaturePasswordAuthComponent, SignaturePinComponent, CertificateSelection],
  imports: [
    CommonModule,
    FormsModule,
    FormPlycaModule,
    TranslateModule,
    DialogModule,
    ScrollPanelModule,
    TableModule,
    DirectivesModule
  ],
  providers: [DialogService]
})
export class SignatureModule { }
